import { VFC } from 'react';
import { useTranslation } from 'next-i18next';

/**
 * @component
 */
const TableHead: VFC = () => {
  const { t } = useTranslation('detail');

  return (
    <thead className="border-y border-gray-6 text-gray-4 text-body-3">
      <tr>
        <th className="py-4 pr-0 text-left tablet:pl-0 desktop:pl-2">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 w-auto font-normal mobile:mx-3">{t('table_headers.name')}</p>
          {/* </div> */}
        </th>
        <th className="py-4 text-right">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.price')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 text-right tablet:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.24hour_percent')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 text-right tablet-table-1:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.7day_percent')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 text-right desktop:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.24h_vol')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 px-3 text-right tablet-table-2:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 truncate font-normal mobile:mx-3"> {t('table_headers.mkt_cap')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 text-center desktop-table-1:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.chart')}</p>
          {/* </div> */}
        </th>
        <th className="hidden py-4 text-center tablet:table-cell">
          {/* <div className="flex items-center"> */}
          <p className="mx-1 font-normal mobile:mx-3">{t('table_headers.operations')}</p>
          {/* </div> */}
        </th>
      </tr>
    </thead>
  );
};

export default TableHead;
